import api from "./api";

// Políticas de SLA por prioridade (empresa ativa).
const slaService = {
  list: () => api.get("/sla").then((r) => r.data),
  save: (rows) => api.put("/sla", rows).then((r) => r.data),
  scanEscalations: () => api.post("/sla/escalations/scan").then((r) => r.data),
};

export default slaService;
